import { AuthProvider } from '@griply/types';

const KNOWN_PROVIDERS = Object.values(AuthProvider);

export const getAuthProvider = (
  providerId: string | undefined,
): AuthProvider | null =>
  KNOWN_PROVIDERS.includes(providerId as AuthProvider)
    ? (providerId as AuthProvider)
    : null;
